import React from 'react';
import { PropTypes } from 'prop-types';

const LocationDetails = ({ address, city, state, postalCode, phones }) => {
	const fullAddress = `${address}, ${city}, ${state} ${postalCode}`;

	return (
		<div
			className="location-details my-4 pl-3"
			role="region"
			aria-label="Location information"
		>
			<address className="m-0" aria-label={`Address: ${fullAddress}`}>
				<p className="m-0">{address}</p>
				<p className="m-0 mb-4">
					{city}, {state} {postalCode}
				</p>
			</address>
			{(phones || []).map((phone) => {
				const isPhoneTypeNotDefault = phone.type !== 'default';
				const phoneLabel = `Call ${
					isPhoneTypeNotDefault ? phone.type : 'main'
				} number ${phone.number}`;
				const showLabel = phones.length > 1;
				return (
					<p className="m-0" key={phone.number}>
						<a
							key={phone.number}
							href={`tel:${phone.number}`}
							aria-label={phoneLabel}
							title={phoneLabel}
						>
							<span className="sr-only">Phone number: </span>
							{phone.number}
						</a>
						{showLabel && (
							<span
								className="text-muted ml-3"
								aria-label={`Phone type: ${phone.type}`}
							>
								{phone.type}
							</span>
						)}
					</p>
				);
			})}
		</div>
	);
};

LocationDetails.propTypes = {
	address: PropTypes.string.isRequired,
	city: PropTypes.string.isRequired,
	state: PropTypes.string.isRequired,
	postalCode: PropTypes.string.isRequired,
	phones: PropTypes.arrayOf(
		PropTypes.shape({
			type: PropTypes.string.isRequired,
			number: PropTypes.string.isRequired
		})
	)
};

export default LocationDetails;
